// TODO: Align statuses with backend when endpoints are integrated
export const BookingApprovalStatus = Object.freeze({
  PendingApproval: 'pendingApproval',
})
